import {
  AppBar,
  Button,
  IconButton,
  ListItemIcon,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import React, { useEffect, useMemo, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { getData } from "../../../../services/library";
import CloseIcon from "@mui/icons-material/Close";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import { Delete } from "@mui/icons-material";
import AddClienteHoja from "./addCliente/AddClienteHoja";
import BajaClienteRuta from "./inactivo/BajaClienteRuta";
import MapaDireccionesModal from "../mapa/MapaDireccionesModal";
import { LoadScript } from "@react-google-maps/api";

function ClientesRuta() {
  const [clientesRuta, setClientesRuta] = useState([]);
  const [clientesOrdenados, setClientesOrdenados] = useState([]);
  const [dataRow, setDataRow] = useState();
  const [alta, setAlta] = useState(false);
  const [baja, setBaja] = useState(false);
  const location = useLocation();
  let navigate = useNavigate();
  const [openMapa, setOpenMapa] = useState(false);

  const onBack = () => navigate(-1);

  //  Calcular distancia
  const calcularDistancia = (punto1, punto2) => {
    const R = 6371;
    const lat1 = (punto1.latitud * Math.PI) / 180;
    const lat2 = (punto2.latitud * Math.PI) / 180;
    const deltaLat = ((punto2.latitud - punto1.latitud) * Math.PI) / 180;
    const deltaLng = ((punto2.longitud - punto1.longitud) * Math.PI) / 180;

    const a =
      Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
      Math.cos(lat1) *
        Math.cos(lat2) *
        Math.sin(deltaLng / 2) *
        Math.sin(deltaLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
  };

  //  Calcular ruta optima
  const calcularRutaOptima = (puntos, inicio) => {
    if (!puntos || puntos.length === 0) return [];

    const puntoMasLejano = [...puntos].sort((a, b) => {
      const distA = calcularDistancia(
        { latitud: inicio.lat, longitud: inicio.lng },
        a,
      );
      const distB = calcularDistancia(
        { latitud: inicio.lat, longitud: inicio.lng },
        b,
      );
      return distB - distA;
    })[0];

    const puntosRestantes = [...puntos];
    const ruta = [puntoMasLejano];

    const indexMasLejano = puntosRestantes.findIndex(
      (p) => p.id === puntoMasLejano.id,
    );
    puntosRestantes.splice(indexMasLejano, 1);

    while (puntosRestantes.length > 0) {
      let ultimoPunto = ruta[ruta.length - 1];
      let distanciaMinima = Infinity;
      let siguientePunto = null;
      let indiceSiguiente = -1;

      for (let i = 0; i < puntosRestantes.length; i++) {
        const distancia = calcularDistancia(ultimoPunto, puntosRestantes[i]);
        if (distancia < distanciaMinima) {
          distanciaMinima = distancia;
          siguientePunto = puntosRestantes[i];
          indiceSiguiente = i;
        }
      }

      if (siguientePunto) {
        ruta.push(siguientePunto);
        puntosRestantes.splice(indiceSiguiente, 1);
      }
    }

    return ruta;
  };

  const obtenerClientes = () => {
    getData("/envasado_clientes_ruta/xhoja/" + location.state.id, (data) => {
      setClientesRuta(data);

      // Preparar sucursal como punto de inicio (misma estructura que en MapaDireccionesModal)
      const sucursalInicio = {
        lat: parseFloat(location.state.latitud_sucursal),
        lng: parseFloat(location.state.longitud_sucursal),
      };

      // Asegurar que cada cliente tiene latitud/longitud como números flotantes
      const clientes = data.map((c) => ({
        ...c,
        latitud: parseFloat(c.latitud),
        longitud: parseFloat(c.longitud),
      }));

      // Usar el MISMO algoritmo que MapaDireccionesModal
      const ordenados = calcularRutaOptima(clientes, sucursalInicio);

      // Agregar número de orden
      const ordenadosConNumero = ordenados.map((cliente, index) => ({
        ...cliente,
        orden: index + 1,
      }));

      setClientesOrdenados(ordenadosConNumero);
    });
  };

  useEffect(() => {
    obtenerClientes();
  }, []);

  const handleAddCliente = () => setAlta(true);
  const handleCloseAdd = () => {
    setAlta(false);
    obtenerClientes();
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "orden",
        header: "Orden",
        maxSize: 50,
      },
      {
        accessorKey: "nombre_cliente",
        header: "Cliente",
        maxSize: 100,
      },
      {
        accessorKey: "direccion_entrega",
        header: "Dirección de Entrega",
        maxSize: 100,
      },
    ],
    [],
  );

  return (
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_Google_maps_key}
      libraries={["places"]}
    >
      <div>
        <AppBar
          sx={{ position: "relative" }}
          style={{ backgroundColor: "#0979b0" }}
        >
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={onBack}>
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Clientes de la hoja {location.state.nombre}
            </Typography>
          </Toolbar>
        </AppBar>

        <MaterialReactTable
          localization={MRT_Localization_ES}
          columns={columns}
          data={clientesOrdenados ?? []}
          layoutMode="grid"
          initialState={{
            density: "compact",
            showGlobalFilter: true,
            pagination: { pageIndex: 0, pageSize: 10 },
          }}
          enableColumnActions={false}
          enableGlobalFilterModes={false}
          enableHiding={false}
          enableRowActions={true}
          enableColumnFilters={false}
          enableFullScreenToggle={false}
          positionActionsColumn="last"
          enableExpandAll={false}
          enableToolbarInternalActions={true}
          muiTableHeadCellProps={{
            align: "left",
            sx: {
              fontSize: 16,
              color: "white",
              fontWeight: "normal",
              backgroundColor: "#2471A3",
              borderColor: "black",
            },
          }}
          muiSearchTextFieldProps={{
            placeholder: "Buscar..",
            sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
            variant: "outlined",
            color: "success",
            size: "small",
          }}
          enableDensityToggle={false}
          enableColumnResizing={true}
          muiTableBodyCellProps={{
            align: "left",
            sx: { color: "black" },
          }}
          renderTopToolbarCustomActions={() => (
            <>
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddBoxTwoToneIcon />}
                onClick={handleAddCliente}
              >
                Agregar Cliente
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                sx={{ ml: 2 }}
                onClick={() => setOpenMapa(true)}
              >
                Ver Mapa
              </Button>
            </>
          )}
          renderRowActions={({ row }) => (
            <Tooltip arrow placement="right" title="Eliminar Cliente">
              <IconButton
                onClick={() => {
                  setDataRow(row.original);
                  setBaja(true);
                }}
                color="error"
              >
                <Delete />
              </IconButton>
            </Tooltip>
          )}
        />

        {alta && (
          <AddClienteHoja
            alta={alta}
            onClose={handleCloseAdd}
            hoja={location.state}
            clientes={clientesRuta}
          />
        )}

        {baja && (
          <BajaClienteRuta
            open={baja}
            setOpen={setBaja}
            cliente={dataRow}
            actualizar={obtenerClientes}
          />
        )}

        {/* Pasar los datos ORDENADOS al modal */}
        <MapaDireccionesModal
          open={openMapa}
          onClose={() => setOpenMapa(false)}
          direcciones={clientesOrdenados}
          latitudSuc={location.state.latitud_sucursal}
          longitudSuc={location.state.longitud_sucursal}
        />
      </div>
    </LoadScript>
  );
}

export default ClientesRuta;
